import { Module } from 'vuex';
import { RootState } from '../store';
import { actions } from '../actions/user.actions';

export const namespace = 'user';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IUserState {}

export const state: IUserState = {};

const namespaced: boolean = true;

export const user: Module<IUserState, RootState> = {
  actions,
  namespaced,
  state,
};
